export default __webpack_public_path__ + "static/media/logo-ecopro-full.0a69fe3a.svg";